import React, { useRef, useState } from 'react';

import { Button, ButtonSize, ButtonType, ButtonVariant } from 'components/Button';
import { arrowRight } from 'icons/default';
import useEventListener from 'utils/useEventListener';
import useOnClickOutside from 'utils/useOnClickOutside';

import { CustomModal } from './CustomModal';
import styles from './ScrollableModal.module.scss';

interface Props {
  buttonContent: string;
  buttonVariant?: ButtonVariant;
  title: string;
  contentVertCenter?: boolean;
  stretch?: boolean;
  dataLayerEvent?: string;
}

export const ScrollableModal: React.FC<Props> = ({
  buttonContent,
  buttonVariant = ButtonVariant.GhostInverted,
  children,
  title,
  contentVertCenter = false,
  stretch,
  dataLayerEvent,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const handleClickOutside = () => {
    setIsOpen(false);
  };

  const handleEscape = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      setIsOpen(false);
    }
  };

  useOnClickOutside(ref, handleClickOutside);
  useEventListener('keydown', handleEscape);

  return (
    <div>
      <Button
        type={ButtonType.Button}
        variant={buttonVariant}
        size={ButtonSize.Large}
        trailingIcon={arrowRight}
        stretch={stretch}
        dataLayerEvent={dataLayerEvent}
        onClick={() => {
          setIsOpen(true);
        }}
      >
        {buttonContent}
      </Button>

      {isOpen && (
        <CustomModal
          title={title ?? ''}
          onClose={() => {
            setIsOpen(false);
          }}
          modRef={ref}
        >
          <div
            className={styles['content-wrapper']}
            style={{ justifyContent: contentVertCenter ? 'center' : '' }}
          >
            {children}
          </div>
        </CustomModal>
      )}
    </div>
  );
};
